module.exports = __webpack_public_path__ + "static/media/guard.264e3aff.png";